/**
 * 목록 페이지 나눔의 순수 규칙.
 *
 * admin(`components/ui/list-pagination.tsx`)이 파트너 목록들에서 쓰는 규칙을 그대로
 * 옮겨 왔다 — 두 앱의 목록이 같은 방식으로 움직이도록. 색만 다르다: admin은 현재
 * 페이지를 주황으로 칠하지만 web 검색 화면은 주황을 카테고리 알약이 쓰고 있어
 * 검정(선택된 핀 반전과 같은 어휘)을 쓴다.
 */

/**
 * 현재 페이지를 가운데 두고 최대 `size`개의 페이지 번호를 슬라이딩으로 고른다.
 * 양끝에서는 창을 끝에 붙여 항상 `size`개(총 페이지가 그보다 적으면 전부)를 낸다.
 *
 * 예) total=10, size=5
 *   current=1  -> [1,2,3,4,5]
 *   current=6  -> [4,5,6,7,8]
 *   current=10 -> [6,7,8,9,10]
 */
export function buildPageWindow(
  current: number,
  total: number,
  size = 5,
): number[] {
  const totalPages = Math.floor(total);
  if (!Number.isFinite(totalPages) || totalPages < 1) return [];

  const span = Math.max(1, Math.min(Math.floor(size), totalPages));
  const page = Math.min(Math.max(Math.floor(current) || 1, 1), totalPages);

  let start = page - Math.floor((span - 1) / 2);
  if (start < 1) start = 1;
  if (start + span - 1 > totalPages) start = totalPages - span + 1;

  return Array.from({ length: span }, (_, i) => start + i);
}

/** 결과 수와 페이지 크기로 총 페이지 수를 구한다. 결과가 없으면 0. */
export function totalPagesFor(count: number, pageSize: number): number {
  if (!Number.isFinite(count) || count <= 0) return 0;
  if (!Number.isFinite(pageSize) || pageSize <= 0) return 0;
  return Math.ceil(count / pageSize);
}

/** 검색 결과 목록의 페이지 크기 — 데스크톱 3열 8행 / 모바일 2열 12행 */
export const SEARCH_PAGE_SIZE = 24;
